import { createAction } from '@reduxjs/toolkit'

export const fecthTokenByUser = createAction<{ tokenByUser: string | undefined }>('account/fecthTokenByUser')
export const fecthCaptchaIdByUser = createAction<{ captchaId: string | undefined }>('account/fecthCaptchaIdByUser')
